import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { User, Lock, AlertCircle } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await login(email, password);
    if (!result.success) setError(result.error);
    setLoading(false);
  };

  return (
    <div className="min-h-screen fm-bg-primary flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={`${process.env.PUBLIC_URL || ''}/logo192.png`} alt="Firmanager" width="72" height="72" className="mx-auto mb-3 rounded-2xl" />
          <h1 className="text-2xl font-bold fm-text-primary">Firmanager</h1>
          <p className="fm-text-secondary mt-1">Mobile · Employee Portal</p>
        </div>
        <form onSubmit={handleSubmit} className="fm-card space-y-4">
          <h2 className="text-lg font-semibold fm-text-primary text-center">Sign In</h2>
          {error && (
            <div className="flex items-center gap-2 p-3 bg-red-500/10 border border-red-500/20 rounded-lg">
              <AlertCircle size={18} className="text-red-400" />
              <span className="text-sm text-red-400">{error}</span>
            </div>
          )}
          <div>
            <label className="fm-label">Email</label>
            <div className="relative">
              <User size={18} className="absolute left-3 top-1/2 -translate-y-1/2 fm-text-secondary pointer-events-none" />
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your.email@company.com" className="fm-input" style={{ paddingLeft: 40 }} required />
            </div>
          </div>
          <div>
            <label className="fm-label">Password</label>
            <div className="relative">
              <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 fm-text-secondary pointer-events-none" />
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter password" className="fm-input" style={{ paddingLeft: 40 }} required />
            </div>
          </div>
          <button type="submit" disabled={loading} className={"w-full fm-btn fm-btn-primary py-3 " + (loading ? "opacity-50" : "")}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <p className="text-center fm-text-secondary text-sm mt-6">Use your employee email to login</p>
      </div>
    </div>
  );
}